import { RouteObject, Outlet } from 'react-router-dom';
import { AuthRequired } from '../components/authentication';

import {
  Area,
  Task,
  Item,
  Areas,
  Tasks,
  Timer,
  Zones,
  Title,
  Titles,
  Timers,
  Inventory,
  Assessment,
  Assessments,
  TaskContent,
  TaskContents
} from '../pages/game-designer/assets';
import Page from '../pages/game-designer/page';
import GameDesigner from '../pages/game-designer';
import GameMap from '../pages/game-designer/game-map';
import { Language } from '../pages/game-designer/resources';
import GameMapZone from '../pages/game-designer/game-map-zone';
import { GameDesigner as GameDesignerLayout } from '../layouts';
import GameOverview from '../pages/game-designer/game-overview';
import { ThemePage } from '../pages/game-designer/assets/theme';
import GameSettings from '../pages/game-designer/game-settings';
import Resource from '../pages/game-designer/resources/resource';
import { NewItem } from '../pages/game-designer/assets/item-new';
import { TimerNew } from '../pages/game-designer/assets/timer-new';
import { TitleNew } from '../pages/game-designer/assets/title-new';
import { GameTestLab } from '../pages/game-designer/game-test-lab';
import GameAnnouncements from '../pages/game-designer/game-announcements';
import GameSalesMarketing from '../pages/game-designer/game-sales-marketing';

export const designerRoutes: RouteObject = {
  path: '/designer',
  element: (
    <AuthRequired>
      <Outlet />
    </AuthRequired>
  ),
  children: [
    {
      path: ':gameId',
      element: <GameDesigner />,
      children: [
        {
          element: <GameDesignerLayout />,
          children: [
            {
              element: <Page className={'page-base--full'} />,
              children: [
                { path: 'map', element: <GameMap /> },
                { path: 'map/:zoneId', element: <GameMapZone /> },
                { path: 'map/task/:taskId', element: <GameMap /> },
                {
                  path: 'assets',
                  children: [
                    { path: 'timers', element: <Timers /> },
                    { path: 'titles', element: <Titles /> },
                    { path: 'task-content', element: <TaskContents /> },
                    { path: 'tasks', element: <Tasks /> },
                    { path: 'zones', element: <Zones /> },
                    { path: 'areas', element: <Areas /> },
                    { path: 'inventory', element: <Inventory /> }
                  ]
                }
              ]
            },
            {
              element: <Page className={'page-base--dynamic'} />,
              children: [
                { index: true, element: <GameOverview /> },

                {
                  path: 'map/:zoneId/:taskContentId',
                  element: <TaskContent />
                },
                {
                  path: 'map/task-content/:taskContentId',
                  element: <TaskContent />
                },

                {
                  path: 'assets',
                  children: [
                    { path: 'inventory/:itemId', element: <Item /> },
                    { path: 'inventory/new', element: <NewItem /> },
                    { path: 'tasks/:taskId', element: <Task /> },
                    {
                      path: 'tasks/:taskId/:taskContentId',
                      element: <TaskContent />
                    },
                    {
                      path: 'task-content/:taskContentId',
                      element: <TaskContent />
                    },
                    {
                      path: 'task-content/:taskContentId/:taskId',
                      element: <TaskContent />
                    },
                    { path: 'timers/new', element: <TimerNew /> },
                    { path: 'timers/:timerId', element: <Timer /> },
                    { path: 'titles/new', element: <TitleNew /> },
                    { path: 'titles/:titleId', element: <Title /> },
                    { path: 'areas/:areaId', element: <Area /> }
                  ]
                },

                {
                  path: 'resources',
                  children: [
                    { path: 'language', element: <Language /> },
                    { path: 'theme', element: <ThemePage /> },
                    { path: 'resource', element: <Resource /> }
                  ]
                },

                { path: 'announcements', element: <GameAnnouncements /> },
                { path: 'sales', element: <GameSalesMarketing /> },
                { path: 'settings', element: <GameSettings /> },
                { path: 'test-lab', element: <GameTestLab /> }
              ]
            }
          ]
        }
      ]
    }
  ]
};
